module.exports = __webpack_public_path__ + "img/y.a0a1fce4.jpg";